export default __webpack_public_path__ + "static/media/astronaut_cards.888b3a12.png";